export default __webpack_public_path__ + "static/media/Vandebilt_Logo.e3e60a12.png";